var _cio = _cio || [];

const CUSTOMER_IO_EVENTS = {
    DEPOSIT_MODAL_OPENED: 'deposit-modal-opened',
    DEPOSIT_STEP_OPENED: {
        1: 'deposit-payment-methods-step',
        2: 'deposit-amount-step',
        3: 'deposit-player-info-step',
        4: 'deposit-saved-profiles-step',
        5: 'deposit-method-info-step'
    },
    WITHDRAWAL_MODAL_OPENED: 'withdrawal-modal-opened',
    NOTIFICATION_BELL_DROPDOWN: 'notification-bell-opened',
    PERSONAL_CABINET_OPENED: 'personal-cabinet-opened',
    PERSONAL_CABINET_TABS: {
        DASHBOARD: 'personal-cabinet-dashboard-tab',
        BONUSES: 'personal-cabinet-bonuses-tab',
        NOTIFICATIONS: 'personal-cabinet-notifications-tab',
        MY_PROFILE: 'personal-cabinet-my-profile-tab',
        GAME_HISTORY: 'personal-cabinet-game-history-tab',
        TRANSACTION_HISTORY: 'personal-cabinet-transaction-history-tab',
    },
    ADD_CURRENCY_MODAL_OPENED: 'add-currency-modal-opened',
    LEFT_GAME_PAGE: 'left-game-page',
    NOTIFICATION_CLICKED: 'notification-clicked'
};

const registerCio = siteId => {
    var a,b,c;a=function(f){return function(){_cio.push([f].
    concat(Array.prototype.slice.call(arguments,0)))}};b=["load","identify",
        "sidentify","track","page"];for(c=0;c<b.length;c++){_cio[b[c]]=a(b[c])};
    var t = document.createElement('script'),
        s = document.getElementsByTagName('script')[0];
    t.async = true;
    t.id = 'cio-tracker';
    t.setAttribute('data-site-id', siteId);
    t.src = 'https://assets.customer.io/assets/track-eu.js';
    s.parentNode.insertBefore(t, s);
}

const setCioIdentity = (id, email, timestamp = null, extraAttributes = {}) => {
    const identityObject = { id: id, email: email };
    if (timestamp) {
        identityObject.created_at = timestamp;
    }
    const merge = { ...identityObject, ...extraAttributes };
    _cio.identify(merge);
}

const trackCioPlayer = (eventName, data = {}, hasArrays = false) => {
    _cio.track(eventName, data, { useArrayParams: hasArrays });
}